import ActionButton from "@/components/Button/ActionButton";

interface StepFooterProps {
  leftButton?: {
    onClick: () => void;
  };
  rightButton: {
    onClick: () => void;
    label: string;
    isLoading?: boolean;
    disabled?: boolean;
  };
}

function StepFooter({ leftButton, rightButton }: StepFooterProps) {
  return (
    <div className="sticky bottom-0 mx-auto bg-white/60 border rounded-md border-gray-300 flex justify-between items-center py-2 w-3/4 p-4">
      {leftButton && (
        <ActionButton
          variant="ghost"
          icon="ChevronLeft"
          iconColor="primary"
          onClick={leftButton.onClick}
        />
      )}
      <div className="flex-grow" />
      <ActionButton
        icon="ChevronRight"
        iconPosition="right"
        onClick={rightButton.onClick}
        isLoading={rightButton.isLoading}
        disabled={rightButton.disabled}
      >
        {rightButton.label}
      </ActionButton>
    </div>
  );
}

export default StepFooter;
